import flagKeys from '@/constants/flagKeys';
import { IBusinessType } from '@/models/business';
import LocationManagement from '@/views/Settings/Locations/Locations.vue';

import { Route } from '../route.model';
import { app } from '@/main';
import { appIsActive } from '../validators/utils';

const validateRouteFlag = () => {
  const business = app.$store.getters['business/getBusinessInfo']
    ? app.$store.getters['business/getBusinessInfo'].business
    : false;

  const availableOperations = new Set([
    IBusinessType.BOTH,
    IBusinessType.INSTORE,
    app.$store.getters['flags/getFlags'].includes(flagKeys.billingModuleV4)
      ? IBusinessType.ONLINE
      : false
  ]);

  const isValid = availableOperations.has(business.type) && appIsActive();

  return business && isValid;
};

const manageLocations = new Route(
  '/settings/locations',
  'settings-locations',
  LocationManagement,
  {
    requiresAuth: true,
    onlyManager: true,
    isResponsive: flagKeys.responsiveDashboard,
    customFlagValidator: validateRouteFlag,
    navbar: {
      name: 'Manage Locations',
      icon: 'manage-locations'
    },
    authRules: {
      authType: ['manager']
    },
    pageView: {
      eventLabel: 'Manage Locations'
    }
  }
);

export { manageLocations };
export default manageLocations;
